import { render, staticRenderFns } from "./SinRegistros.vue?vue&type=template&id=1226671c"
import script from "./SinRegistros.vue?vue&type=script&lang=js"
export * from "./SinRegistros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports